import { makeStyles, Theme } from '@material-ui/core/styles'

export const useStyles = makeStyles<Theme>((theme) => ({
  successText: {
    fontSize: '1.2rem',
    marginBottom: theme.spacing(2)
  },
  description: {
    marginBottom: theme.spacing(3)
  },
  separator: {
    width: '100%',
    height: 1,
    backgroundColor: '#E0E0E0',
    margin: theme.spacing(4, 0)
  }
}))
